import React, {useEffect, useRef, useState} from "react";
import "./css/BonusShares.css";
import {useRefreshContext} from "../context/RefreshContext"; // Import the new CSS file
import {deleteContractNote, fetchManualContractNoteNo, saveContractNote} from "@portfolio/utils/PFService"; // Import the new CSS file

const BonusShares = ({ symbol, onClose, onSave,clientId,isDisplayClick,contractNoteDTO }) => {
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]); // Default to today
    const [quantity, setQuantity] = useState("");
    const [narration, setNarration] = useState("");
    const formRef = useRef(null);
    const {refreshPFdata} = useRefreshContext(); // 🔹 Subscribe to global refresh

    useEffect(() => {
        if(isDisplayClick){
            setQuantity(contractNoteDTO.transactions[0].quantity);
            setNarration(contractNoteDTO.transactions[0].narration);
        }
    }, []);

    const handleSave = async () => {
        let manualNote = contractNoteDTO?.contractNote?.contractNoteNo || "";
        if(!isDisplayClick) {
            manualNote = await fetchManualContractNoteNo("BONUS-CNT-"); // ✅ Now we get the actual value
            //console.log("📌 manualContractNoteNo BEFORE using:", manualNote); // ❌ Logs empty array []
        }
        if (!quantity || isNaN(quantity) || quantity <= 0) {
            alert("Please enter a valid quantity.");
            return;
        }
        const formData = new FormData(formRef.current);

        const parsedQuantity = parseInt(quantity, 10);
        const narrationText = narration; // ✅ Correct usage of `useState` variable

        // Construct ContractNoteDTO
        const newContractNote = {
            contractNote: {
                contractNoteNo: manualNote,
                clientId: clientId,
                brokerName: "",
                tradeDate: formData.get("date"),
                cnoteType: "BONUS",
            },
            cnotesCharge: {
                contractNoteNo: "",
                securitiesTransactionTaxEquity: "",
                stampDutyEquity: "",
                igstEquity: "",
                exchangeTransactionChargesEquity: "",
                otherCharges: "",
                netAmountNetTotal: 0.0,
            },
            transactions: [  // ✅ Ensure this is an array
                { // ✅ Include idx here
                    type: "BonusTransactionDTO",
                    contractNoteNo: manualNote,
                    clientId: clientId,
                    symbol: symbol,
                    transactionType: "Bonus",
                    quantity: parsedQuantity,
                    /*                    weightedAvgPrice: 0,
                                        brokerage: 0,
                                        totalValue: 0,
                                        netQuantity: parsedQuantity,
                                        netObligation: 0,*/
                    tradeDate: formData.get("date"),
                    narration: narrationText ?? "" // ✅ Ensure narration is not null
                }
            ],
            cnoteType: "BONUS"
        };

        try {
            const result =await saveContractNote(newContractNote, isDisplayClick); // Wait for save to complete
            if (result.success) {
                refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
                onClose(); // Close the popup after successful Save
            }
        } catch (error) {
            console.error("Error saving contract note:", error);
        }
    };

    const handleDelete = async () => {
        try {
            const result =await deleteContractNote(contractNoteDTO.contractNote.contractNoteNo); // Wait for save to complete
            if (result.success) {
                refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
                onClose(); // Close the popup after successful Save
            }
        } catch (error) {
            console.error("Error deleting Bonus:", error);
        }
    };

    return (
        <div className="popup-overlay bonus-overlay">
            <form ref={formRef}>
                <div className="bonus-popup" onClick={(e) => e.stopPropagation()}>
                    <div className="header-row">
                        <h3>Bonus</h3>
                        <h3>{clientId}</h3>
                    </div>
                    {/* Transaction Label */}
                    {/*<div className="form-group ">
                        <label className="general-label">Transaction:</label>
                        <span className="readonly-text">Bonus</span>
                    </div>*/}

                    <div className="form-group bonus-shares-from">
                        <label className="general-label">Bonus Shares From:</label>
                        {/*<span className="readonly-text">{symbol}</span>*/}
                        <input
                            type="String"
                            name="before-merger-quantity"
                            value={symbol}
                            disabled
                        />
                    </div>

                    {/* Transaction Details */}
                    <h5>Transaction:</h5>

                    <div className="form-group">
                        <label className="general-label">Date:</label>
                        <input
                            name="date" // ✅ Add name attribute so FormData can find it
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Quantity:</label>
                        <input
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            min="1"
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Narration:</label>
                        <textarea
                            value={narration}
                            onChange={(e) => setNarration(e.target.value)}
                            rows="3"
                        />
                    </div>

                    {/* Save and Cancel Buttons */}
                    <div className="contract-buttons">
                        {isDisplayClick && (
                            <button type="button" className="delete-button" onClick={handleDelete}>
                                Delete CNote
                            </button>
                        )}
                        <div className="right-buttons">
                            <button type="button" className="save-button" onClick={handleSave}>Save</button>
                            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
</div>
)
    ;
};

export default BonusShares;
